import { useDispatch } from "react-redux";
import { importFromYaml } from "../controller/modelYamlImport";
import * as systemUtils from "../controller/utils/systemUtils";
import { setSpinner, setSpinnerMessage } from "../redux/slice/overlaySlice";
import { setRoot } from "../redux/slice/structureSlice";

const MODEL_PATHS = {
  initial: "./example/initial.yaml",
  default: "./example/default.yaml",
  workshop: "./example/workshop.yaml",
  epicBattle: "./example/epicbattle.yaml",
  tutorial1: "./example/tutorial-1.yaml",
  tutorial2: "./example/tutorial-2.yaml",
  tutorial3: "./example/tutorial-3.yaml"
};

export const useYamlImport = () => {
  const dispatch = useDispatch();

  const processYaml = (content) => {
    const { model, error } = importFromYaml(content);

    if (!model) {
      alert(`The file could not be imported! ${error}`);
      console.log(`The file could not be imported! ${error}`);
    } else {
      dispatch(setRoot(model, 0));
    }

    dispatch(setSpinner(false));
  };

  const loadFromText = async (text) => {

    if (!text) {
      return;
    }

    dispatch(setSpinner(true));
    dispatch(setSpinnerMessage("parsing"));

    try {
      processYaml(text);
    } catch (error) {
      console.error("Failed to update YAML:", error);
      dispatch(setSpinner(false));
    }
  };

  const loadFromUrl = async (url) => {
    dispatch(setSpinner(true));
    dispatch(setSpinnerMessage("parsing"));

    try {
      const response = await fetch(url);
      const content = await response.text();
      processYaml(content);
    } catch (error) {
      console.error("Failed to fetch YAML:", error);
      dispatch(setSpinner(false));
    }
  };

  const loadPredefinedModel = (modelKey) => {
    const targetUrl = MODEL_PATHS[modelKey];
    if (targetUrl) {
      loadFromUrl(targetUrl);
    } else {
      console.error(`Model key "${modelKey}" not found in predefined paths.`);
    }
  };

  const loadFromFile = async (file) => {
    if (!file) return;

    dispatch(setSpinner(true));
    dispatch(setSpinnerMessage("loading"));

    try {
      const content = await systemUtils.readTextFromFile(file);
      processYaml(content);
    } catch (error) {
      console.error("Failed to read file:", error);
      dispatch(setSpinner(false));
    }
  };

  return { loadFromText, loadFromFile, loadPredefinedModel };
};